import * as Oidc from 'oidc-client';
import * as Model from "../../user/model";
import createOidcMiddleware, {createUserManager, loadUser} from "redux-oidc";
import {applyMiddleware, createStore, Store} from "redux";
import thunk from "redux-thunk";
import {rootReducer} from "../../rootReducer";
import {oidcUtils} from "./OidcUtils";
import {OidcProviderInfo} from "../../model";

// The following Log is used by oidc-client library. Do not deliver in production.
//Log.logger = console;
//Log.level = Log.INFO;


//The client_id are set in Spring property files in Erdas APOLLO 2023. We need to have these values available at runtime for Studio.
// The UserManager is loaded on start-up of Studio.

let userManager: Oidc.UserManager;
const initializeUserManager = (oidcProviderInfo: OidcProviderInfo, getApi): Store<any> => {
  const userManagerConfig = copySettingsToUserManagerConfig(oidcProviderInfo);
  //create the userManager for oidc
  userManager = createUserManager(userManagerConfig);
  // create the middleware
  const oidcMiddleware = createOidcMiddleware(userManager);
  const middleware = applyMiddleware(thunk.withExtraArgument({getApi}), oidcMiddleware);
  //Use composeWithDevTools for debug environment to view redux state;however, do not use in production
  //add import {composeWithDevTools} from "redux-devtools-extension";
  //const store: Store<any> = createStore(rootReducer, {}, composeWithDevTools(middleware));
  const store: Store<any> = createStore(rootReducer, {}, middleware);
  loadUser(store, userManager);
  return store;
}
const copySettingsToUserManagerConfig = (oidcProviderInfo: OidcProviderInfo): Oidc.UserManagerSettings => {
  const baseUrl = oidcUtils.getOidcBaseUrl();
  return {
    client_id: oidcProviderInfo.clientId,
    authority: oidcProviderInfo.authorizationEndpoint,
    redirect_uri: baseUrl.replace("/index.html","") + "/callback",
    silent_redirect_uri: baseUrl + "#/silent_renew",
    post_logout_redirect_uri: baseUrl + "#/login",
    response_type: "code",
    response_mode: "query",
    scope: oidcProviderInfo.scope,
    automaticSilentRenew: true,
    revokeAccessTokenOnSignout: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    metadata: {
      issuer: oidcProviderInfo.issuer,
      jwks_uri: oidcProviderInfo.jwkSetEndpoint,
      userinfo_endpoint: oidcProviderInfo.userInfoEndpoint,
      authorization_endpoint: oidcProviderInfo.authorizationEndpoint,
      token_endpoint: oidcProviderInfo.tokenEndpoint,
      end_session_endpoint: oidcProviderInfo.logoutEndpoint,
    },
  }
};

const copyOidcUserToCurrentUser = (oidcUser: Oidc.User): Model.User => {
  let current: Model.User = null;
   try {
    if (oidcUser === null || typeof (oidcUser.profile) === null) {
      return null
    }
    current = {
      username: getOidcUserName(oidcUser),
      userTourCompleted: true
    }
  } catch (error) {
    throw new Error("Copy user error :" + error);
  }
  return current;
}

const getOidcUserName = (oidcUser: Oidc.User): string => {
  let user = oidcUser?.profile?.preferred_username;
  if (user === undefined) {
    if (oidcUser?.profile?.email) {
      user = oidcUser?.profile?.email;
    }
  }
  if ((user === "" || user === undefined) && oidcUser.hasOwnProperty("access_token")) {
      const json = JSON.parse(window.atob(oidcUser.access_token.split('.')[1]))
      if (json?.hasOwnProperty("preferred_username")) {
        user = json.preferred_username;
      } else {
        user = "missing-user-name"
      }
  }
  return user;
}

const createCurrentUser = (username: string, password: string) => {
  const newUser: Model.User = {
    username,
    userTourCompleted: true
  }
  return newUser;
}

export {
  userManager,
  createCurrentUser,
  initializeUserManager,
  copyOidcUserToCurrentUser
}